import React from "react";
import { Link } from "react-router-dom";

const CardDashboard = ({ color, icons, title, name, value, state }) => {
  return (
    <Link
      to={`/tickets/${name}`}
      state={state}
      className="flex w-full h-20 bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow cursor-pointer"
    >
      <div
        style={{ backgroundColor: `${color}20`, color: color }}
        className="w-20 h-20 flex items-center justify-center text-3xl"
      >
        {icons}
      </div>
      <div className="px-4 flex flex-1 flex-col justify-center whitespace-nowrap">
        <div className="text-sm">{title}</div>
        <div className="font-bold">{value}</div>
      </div>
    </Link>
  );
};

export default CardDashboard;
